import './WebsiteUnderUpdate.css';

function WebsiteUnderUpdate() {
  return (
    <main className="website-update" aria-labelledby="website-update-title">
      <div className="website-update__glow website-update__glow--top" />
      <div className="website-update__glow website-update__glow--bottom" />

      <section className="website-update__content">
        <div className="website-update__mark" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <p className="website-update__eyebrow">Auto Vignette</p>
        <h1 id="website-update-title">We are making things better.</h1>
        <p className="website-update__message">
          Our website is temporarily unavailable while we complete some updates.
          Please check back soon.
        </p>
        <div className="website-update__status" role="status">
          <span className="website-update__status-dot" />
          Updates in progress
        </div>
      </section>
    </main>
  );
}

export default WebsiteUnderUpdate;